export enum Organizations {
  PREQUEL = 1,
  NOVATIO = 2,
  UNBOUND = 3,
  GT_SCHOOL = 4,
  FUTURE2_MARTINEZ = 5,
  FUTURE2_GREGG = 6
}

type SchoolHostConfig = {
  orgId: Organizations;
  hostIncludes: string[];
  cookieKey: string;
  label: string;
  origins: string[];
};

export const SCHOOL_HOSTS: SchoolHostConfig[] = [
  {
    orgId: Organizations.NOVATIO,
    hostIncludes: ['novatio.school'],
    cookieKey: 'novatio_context',
    label: 'Novatio',
    origins: ['https://portal.novatio.school', 'https://portalstaging.novatio.school']
  },
  {
    orgId: Organizations.UNBOUND,
    hostIncludes: ['unbound.school'],
    cookieKey: 'unbound_context',
    label: 'Unbound',
    origins: ['https://portal.unbound.school', 'https://portalstaging.unbound.school']
  },
  {
    orgId: Organizations.GT_SCHOOL,
    hostIncludes: ['gt.school'],
    cookieKey: 'gt_context',
    label: 'GT',
    origins: ['https://portal.gt.school', 'https://portalstaging.gt.school']
  },
  {
    orgId: Organizations.FUTURE2_MARTINEZ,
    hostIncludes: ['future2-martinez.com', 'portal-martinez.alphapublic.school'],
    cookieKey: 'future2_martinez_context',
    label: 'Future2 at C. Martinez',
    origins: [
      'https://portal.future2-martinez.com',
      'https://portalstaging.future2-martinez.com',
      'https://portal-martinez.alphapublic.school'
    ]
  },
  {
    orgId: Organizations.FUTURE2_GREGG,
    hostIncludes: ['future2-gregg.com', 'portal-gregg.alphapublic.school'],
    cookieKey: 'future2_gregg_context',
    label: 'Future2 at Gregg Elementary',
    origins: [
      'https://portal.future2-gregg.com',
      'https://portalstaging.future2-gregg.com',
      'https://portal-gregg.alphapublic.school'
    ]
  }
];

export const organizations_select = [
  {
    label: 'Prequel',
    value: Organizations.PREQUEL
  },
  {
    label: 'Novatio',
    value: Organizations.NOVATIO
  },
  {
    label: 'Unbound',
    value: Organizations.UNBOUND
  },
  {
    label: 'GT',
    value: Organizations.GT_SCHOOL
  },
  {
    label: 'Future2 at C. Martinez',
    value: Organizations.FUTURE2_MARTINEZ
  },
  {
    label: 'Future2 at Gregg Elementary',
    value: Organizations.FUTURE2_GREGG
  }
];

export const PORTAL_ALLOWED_ORIGINS = [
  'http://localhost:3000',
  'https://portal.joinprequel.com',
  'https://portalstaging.joinprequel.com',
  ...SCHOOL_HOSTS.flatMap((school) => school.origins)
];

export function orgIdFromHost(host: string): Organizations {
  const found = SCHOOL_HOSTS.find((school) => school.hostIncludes.some((fragment) => host.includes(fragment)));
  return found?.orgId ?? Organizations.PREQUEL;
}

export function cookieKeyFromHost(host: string): string {
  const found = SCHOOL_HOSTS.find((school) => school.hostIncludes.some((fragment) => host.includes(fragment)));
  return found?.cookieKey ?? 'prequel_context';
}
